/*
  APBD / Holiday Sale shared runtime.
  Resolves the live price phase from the hero's phase blocks, renders sale
  prices (mirroring the discount app's floored per-unit math), handles
  add to cart + cart drawer notify, the gift meter and dock, recipe tabs
  and scroll reveals. Preview any date with ?hs_date=2026-11-27
*/
(function () {
  if (window.HS) return;
  var HS = (window.HS = {});
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  HS.money = function (cents) {
    var fmt = window.HS_MONEY_FORMAT || '${{amount}}';
    var v = (Math.max(0, cents) / 100).toFixed(2).split('.');
    var whole = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v[0] + ',' + v[1])
      .replace(/\{\{\s*amount\s*\}\}/g, whole + '.' + v[1]);
  };

  HS.now = function () {
    try {
      var q = new URLSearchParams(location.search).get('hs_date');
      if (q) {
        var d = new Date(q.length <= 10 ? q + 'T12:00:00-05:00' : q);
        if (!isNaN(d)) return d;
      }
    } catch (e) {}
    return new Date();
  };

  HS.phases = function () {
    var out = [];
    document.querySelectorAll('script[data-hs-phases]').forEach(function (s) {
      try { out = out.concat(JSON.parse(s.textContent)); } catch (e) {}
    });
    return out;
  };

  HS.phase = function () {
    var n = HS.now();
    var list = HS.phases();
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (n >= new Date(p.start) && n <= new Date(p.end)) return p;
    }
    return null;
  };

  HS.sale = function (cents, pct) { return cents - Math.floor(cents * pct / 100); };

  HS.notify = function () {
    [
      function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); },
      function () { document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true })); },
      function () { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); },
      function () { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); }
    ].forEach(function (f) { try { f(); } catch (e) {} });
  };

  HS.cart = function () {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { document.dispatchEvent(new CustomEvent('hs:cart', { detail: c })); return c; });
  };

  HS.add = function (items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.');
        HS.notify();
        HS.cart();
        return d;
      });
    });
  };

  /* Tokens like [[pct]] in any copy on the page, including the FAQ */
  function fillTokens(p) {
    var main = document.getElementById('MainContent') || document.body;
    var map = p ? { pct: p.pct, name: p.name, dates: p.dates, end: p.end_label || p.dates } : null;
    var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, null);
    var n, hits = [];
    while ((n = walker.nextNode())) if (n.nodeValue.indexOf('[[') > -1) hits.push(n);
    hits.forEach(function (t) {
      if (!t.__hs) t.__hs = t.nodeValue;
      var box = t.parentNode && t.parentNode.closest ? t.parentNode.closest('p, li, .hs-lede, .hs-fine, .accordion') : null;
      if (box && !box.closest('[data-hs-when]')) box.hidden = !p;
      t.nodeValue = t.__hs.replace(/\[\[(\w+)\]\]/g, function (m, k) { return map && map[k] != null ? map[k] : ''; });
    });
  }

  function applyPhase(scope) {
    var p = HS.phase();
    document.documentElement.classList.toggle('hs-live', !!p);
    scope.querySelectorAll('[data-hs-when]').forEach(function (el) {
      el.hidden = el.getAttribute('data-hs-when') === 'active' ? !p : !!p;
    });
    scope.querySelectorAll('[data-hs-field]').forEach(function (el) {
      var k = el.getAttribute('data-hs-field');
      if (p && p[k] != null) el.textContent = p[k];
    });
    scope.querySelectorAll('[data-hs-price]').forEach(function (el) {
      var cents = parseInt(el.getAttribute('data-price'), 10) || 0;
      var mode = el.getAttribute('data-mode');
      var pct = mode === 'tier' ? (p ? p.pct : 0) : mode === 'fixed' ? parseFloat(el.getAttribute('data-pct')) || 0 : 0;
      var fixedPrice = el.getAttribute('data-fixed-price');
      var now = el.querySelector('[data-now]');
      var was = el.querySelector('[data-was]');
      var nowCents = fixedPrice ? parseInt(fixedPrice, 10) : HS.sale(cents, pct);
      if (now) now.textContent = HS.money(nowCents);
      if (was) {
        was.hidden = nowCents >= cents;
        was.textContent = HS.money(cents);
      }
      el.classList.remove('hs-pending');
    });
    fillTokens(p);
    countdown(scope, p);
    return p;
  }

  var cdTimer;
  function countdown(scope, p) {
    var els = scope.querySelectorAll('[data-hs-countdown]');
    if (!els.length) return;
    function tick() {
      var ms = p ? new Date(p.end) - HS.now() : 0;
      els.forEach(function (el) {
        el.hidden = !p || ms <= 0;
        var d = Math.floor(ms / 864e5), h = Math.floor((ms % 864e5) / 36e5), m = Math.floor((ms % 36e5) / 6e4);
        var set = function (k, v) { var x = el.querySelector('[data-cd="' + k + '"]'); if (x) x.textContent = String(Math.max(0, v)).padStart(2, '0'); };
        set('d', d); set('h', h); set('m', m);
      });
    }
    tick();
    clearInterval(cdTimer);
    if (p) cdTimer = setInterval(tick, 30000);
  }

  /* Add buttons: [data-hs-add] inside a [data-hs-card]; optional variant select */
  function bindAdds(scope) {
    scope.querySelectorAll('[data-hs-add]').forEach(function (btn) {
      if (btn.__hs) return;
      btn.__hs = true;
      var label = btn.textContent;
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-hs-card]') || btn.parentNode;
        var sel = card.querySelector('[data-hs-variant]');
        var id = sel ? sel.value : btn.getAttribute('data-variant-id');
        if (!id) return;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        HS.add([{ id: Number(id), quantity: 1 }])
          .then(function () {
            btn.classList.add('is-added');
            btn.textContent = btn.getAttribute('data-added') || 'Added';
          })
          .catch(function (e) {
            btn.textContent = e.message || 'Try again';
          })
          .then(function () {
            btn.removeAttribute('aria-busy');
            setTimeout(function () {
              btn.disabled = false;
              btn.classList.remove('is-added');
              btn.textContent = label;
            }, 2400);
          });
      });
    });
    scope.querySelectorAll('[data-hs-variant]').forEach(function (sel) {
      if (sel.__hs) return;
      sel.__hs = true;
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var box = sel.closest('[data-hs-card]').querySelector('[data-hs-price]');
        if (box && opt) { box.setAttribute('data-price', opt.getAttribute('data-price')); applyPhase(box.parentNode); }
      });
    });
  }

  function reveal(scope) {
    var els = scope.querySelectorAll('[data-hs-reveal]');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.3 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Gift meter + dock */
  function meters(scope) {
    scope.querySelectorAll('[data-hs-meter]').forEach(function (m) {
      if (m.__hs) return;
      m.__hs = true;
      var goal = Math.round(parseFloat(m.getAttribute('data-goal')) * 100) || 5000;
      var dock = document.querySelector('[data-hs-dock="' + m.getAttribute('data-hs-meter') + '"]');
      var tpl = {
        empty: m.getAttribute('data-msg-empty'),
        need: m.getAttribute('data-msg-need'),
        done: m.getAttribute('data-msg-done')
      };
      var last = -1;
      function render(cart) {
        var t = cart ? cart.total_price : 0;
        var on = t >= goal;
        var pct = Math.max(4, Math.min(100, (t / goal) * 100));
        var msg = t === 0 ? tpl.empty : on ? tpl.done : tpl.need.replace('[[left]]', HS.money(goal - t));
        [m, dock].forEach(function (root) {
          if (!root) return;
          root.classList.toggle('is-on', on);
          root.querySelectorAll('[data-m-msg]').forEach(function (e) { e.textContent = msg; });
          root.querySelectorAll('[data-m-tot]').forEach(function (e) { e.textContent = HS.money(t); });
          root.querySelectorAll('[data-m-bar]').forEach(function (e) {
            if (root === m && !m.classList.contains('is-in')) e.setAttribute('data-w', pct);
            else e.style.width = pct + '%';
          });
        });
        if (dock && last >= 0 && t !== last && !reduce) {
          dock.classList.remove('is-bump'); void dock.offsetWidth; dock.classList.add('is-bump');
        }
        last = t;
      }
      document.addEventListener('hs:cart', function (e) { render(e.detail); });
      [m, dock].forEach(function (r) {
        if (r) r.addEventListener('click', function () { if (r.classList.contains('is-on') && window.HSGWP) HSGWP.prompt(); });
      });
      ['cart:updated', 'cart:change', 'upcart:cart-updated'].forEach(function (ev) {
        document.addEventListener(ev, function () { HS.cart(); });
      });
      var wake = function () {
        m.classList.add('is-in');
        requestAnimationFrame(function () {
          m.querySelectorAll('[data-m-bar]').forEach(function (e) { e.style.width = (e.getAttribute('data-w') || 4) + '%'; });
        });
      };
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { wake(); io.disconnect(); } }, { threshold: 0.4 });
        io.observe(m);
      } else wake();
      if (dock) {
        var place = function () {
          var vh = innerHeight, mr = m.getBoundingClientRect();
          var inZone = false;
          document.querySelectorAll('[data-hs-dock-zone]').forEach(function (z) {
            var r = z.getBoundingClientRect();
            if (r.top < vh * 0.6 && r.bottom > vh * 0.4) inZone = true;
          });
          var show = mr.bottom < 0 && inZone;
          dock.classList.toggle('is-show', show);
          dock.setAttribute('aria-hidden', String(!show));
        };
        var ticking = false;
        addEventListener('scroll', function () {
          if (ticking) return; ticking = true;
          requestAnimationFrame(function () { ticking = false; place(); });
        }, { passive: true });
        addEventListener('resize', place);
        place();
      }
      HS.cart().catch(function () { render(null); });
    });
  }

  /* Recipe tabs */
  function tabs(scope) {
    scope.querySelectorAll('[data-hs-tabs]').forEach(function (wrap) {
      if (wrap.__hs) return;
      wrap.__hs = true;
      var btns = wrap.querySelectorAll('[data-tab]');
      var panes = wrap.querySelectorAll('[data-pane]');
      function set(k) {
        btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-tab') === k)); });
        panes.forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== k; });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-tab')); }); });
      var def = wrap.getAttribute('data-default');
      if (def && wrap.querySelector('[data-tab="' + def + '"]')) { set(def); return; }
      var sw = wrap.getAttribute('data-switch');
      var idx = sw && HS.now() >= new Date(sw) && btns[1] ? 1 : 0;
      if (btns[idx]) set(btns[idx].getAttribute('data-tab'));
    });
  }

  HS.init = function (scope) {
    scope = scope || document;
    applyPhase(document);
    bindAdds(scope);
    reveal(scope);
    meters(scope);
    tabs(scope);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { HS.init(); });
  else HS.init();
  document.addEventListener('shopify:section:load', function (e) { HS.init(e.target); });
})();
